import toast from "react-hot-toast";
import { push } from "redux-first-history";
import { MILISECONDS_TO_FETCH_GAME_STATE } from "../../utils/constants";
import * as http from "../../utils/requests";
import { game } from "../reducers/game";
import store from "../store";
import { sleep } from "../../utils/utils";
import shuffleSound from '../../assets/voices/shuffle.mp3';
import cantPlayCardSound from '../../assets/voices/cantPlayCard.mp3';
import playSound from '../../assets/voices/play.mp3';

export const {
  updateGame,
  updateCard,
  updateFlipped,
  setGameId,
  timerDisable,
  timerReset,
  timerTick,
  timerTrucoDisable,
  timerTrucoReset,
  timerTrucoTick,
} = game.actions;

const shuffleSoundAction = new Audio(shuffleSound);
const cantPlayCardSoundAction = new Audio(cantPlayCardSound);
const playCardSound = new Audio(playSound);

// One-shot check pra usar em telas fora do /game (Home, etc).
// Se o jogador tem partida ativa no back, redireciona pra /game
// — cobre o caso de F5 no meio do jogo ou fechar o app no mobile.
export const redirectIfInGame = () => async (dispatch) => {
  try {
    const response = await http.get("games/current");
    if (response.status === 200 && response.data) {
      const { p1, p2 } = response.data;
      const gameEnded = (p1?.game_score ?? 0) >= 12 || (p2?.game_score ?? 0) >= 12;
      if (!gameEnded) {
        dispatch(updateGame(response.data));
        dispatch(push("/game"));
      }
    }
  } catch (error) {
    // Sem jogo ativo — não faz nada, jogador segue na página atual
  }
};

export const fetchGameState = () => async (dispatch) => {
  try {
    const response = await http.get("games/current");
    if (response.status === 200) {
      const { game } = store.getState();
      const { timer, state } = game;
      const { data } = response;

      // GAME STATE É O ESTADO PRESENTE
      // RESPONSE DATE É O ESTADO FUTURO

      if (data) {
        if (timer === undefined) {
          await dispatch(timerDisable());
        }

        // GAME END
        // Atualiza o estado e aguarda ~6s pra o jogador ver a ultima carta
        // jogada e a mensagem de vitoria/derrota (GameOutcomeModal) antes
        // de redirecionar pra home
        if (data.p1.game_score >= 12) {
          dispatch(updateGame(data));
          await sleep(6000);
          dispatch(push("/"));
          return;
        } else if (data.p2.game_score >= 12) {
          dispatch(updateGame(data));
          await sleep(6000);
          dispatch(push("/"));
          return;
        } else {
          setTimeout(
            () => dispatch(fetchGameState()),
            MILISECONDS_TO_FETCH_GAME_STATE
          );
        }

        const newWinner =
          !game.state.round_winner && data.round_winner ? true : false;

        const empate =
          data.p1.round_score - state.p1.round_score === 1 &&
          data.p2.round_score - state.p2.round_score === 1;
        dispatch(updateGame(data));

        if (
          !newWinner &&
          !empate &&
          state.p1.round_score < data.p1.round_score
        ) {
          toast(
            (
              <span>
                <span style={{ color: "#ffffff" }}>Você </span>
                <span style={{ color: "#38b890" }}>ganhou a rodada!</span>
              </span>
            ),
            {
              icon: null,
              position: "top-center",
              style: {
                background: "rgba(32, 18, 19, 0.92)",
                border: "1px solid #4D3C34",
                borderRadius: "6px",
                padding: "16px 42px",
                fontSize: "18px",
                fontWeight: 700,
                maxWidth: "342px",
                width: "auto",
                textAlign: "center",
                marginTop: "40vh",
              },
            }
          );
          dispatch(timerDisable());
          dispatch(updateGame(data));
        }

        if (
          !newWinner &&
          !empate &&
          state.p2.round_score < data.p2.round_score
        ) {
          toast(
            (
              <span>
                <span style={{ color: "#ffffff" }}>Você </span>
                <span style={{ color: "#E55340" }}>perdeu a rodada!</span>
              </span>
            ),
            {
              icon: null,
              position: "top-center",
              style: {
                background: "rgba(32, 18, 19, 0.92)",
                border: "1px solid #4D3C34",
                borderRadius: "6px",
                padding: "16px 42px",
                fontSize: "18px",
                fontWeight: 700,
                maxWidth: "342px",
                width: "auto",
                textAlign: "center",
                marginTop: "40vh",
              },
            }
          );
          dispatch(timerDisable());
          dispatch(updateGame(data));
          await sleep(1000);
        }

        if (!newWinner && empate) {
          dispatch(timerDisable());
          dispatch(updateGame(data));
          await sleep(1000);
        }

        if (newWinner) {
          if (state.p1.id === data.round_winner) {
            toast(
              (
                <span>
                  <span style={{ color: "#ffffff" }}>Você </span>
                  <span style={{ color: "#38b890" }}>ganhou a mão!</span>
                </span>
              ),
              {
                icon: null,
                position: "top-center",
                style: {
                  background: "rgba(32, 18, 19, 0.92)",
                  border: "1px solid #4D3C34",
                  borderRadius: "6px",
                  padding: "16px 42px",
                  fontSize: "18px",
                  fontWeight: 700,
                  maxWidth: "342px",
                  width: "auto",
                  textAlign: "center",
                  marginTop: "40vh",
                },
              }
            );
            dispatch(timerDisable());
            shuffleSoundAction.play().catch(() => {});
            await sleep(1000);
          } else {
            toast(
              (
                <span>
                  <span style={{ color: "#ffffff" }}>Você </span>
                  <span style={{ color: "#E55340" }}>perdeu a mão!</span>
                </span>
              ),
              {
                icon: null,
                position: "top-center",
                style: {
                  background: "rgba(32, 18, 19, 0.92)",
                  border: "1px solid #4D3C34",
                  borderRadius: "6px",
                  padding: "16px 42px",
                  fontSize: "18px",
                  fontWeight: 700,
                  maxWidth: "342px",
                  width: "auto",
                  textAlign: "center",
                  marginTop: "40vh",
                },
              }
            );
            shuffleSoundAction.play().catch(() => {});
            await sleep(1000);
          }
        }

        dispatch(updateGame(data));

        if (timer === undefined) {
          dispatch(timerReset());
          dispatch(timerStart());
        }
        
        if (state.truco_challenge_running === 0 && data.truco_challenge_running === 1) {
          dispatch(timerTrucoReset());
          dispatch(timerReset());
        }
        
        if (state.truco_challenge_running === 1 && state.truco_challenger_id === state.p1.id && data.truco_challenger_id === state.p2.id) {
          dispatch(timerTrucoReset());
          dispatch(timerReset());
        }
        
        if (state.truco_challenge_running === 1 && state.truco_challenger_id === state.p2.id && data.truco_challenger_id === state.p1.id) {
          dispatch(timerTrucoReset());
          dispatch(timerReset());
        }

        if (
          state.truco_challenge_running === 1 &&
          data.truco_challenge_running === 0 &&
          state.truco_challenger_id === state.p1.id
        ) {
          // Refuse pode ser detectado por 2 sinais, dependendo de qual
          // transição o polling captura: round_winner vira p1, OU o
          // game_score do p1 sobe (ganhou a mão pela fuga do oponente).
          const opponentRefused =
            (!state.round_winner && data.round_winner === state.p1.id) ||
            data.p1.game_score > state.p1.game_score;

          const toastStyle = {
            icon: null,
            position: "top-center",
            style: {
              background: "rgba(32, 18, 19, 0.92)",
              border: "1px solid #4D3C34",
              borderRadius: "6px",
              padding: "16px 42px",
              fontSize: "18px",
              fontWeight: 700,
              maxWidth: "342px",
              width: "auto",
              textAlign: "center",
              marginTop: "40vh",
            },
          };

          if (opponentRefused) {
            toast(
              (
                <span>
                  <span style={{ color: "#ffffff" }}>Oponente </span>
                  <span style={{ color: "#38b890" }}>fugiu!</span>
                </span>
              ),
              toastStyle
            );
          } else {
            toast(
              (
                <span>
                  <span style={{ color: "#ffffff" }}>Oponente </span>
                  <span style={{ color: "#38b890" }}>aceitou!</span>
                </span>
              ),
              toastStyle
            );
          }
        }

        if (!state.p1.first_play && data.p1.first_play) {
          dispatch(timerDisable());
          dispatch(timerReset());
        }

        if (!state.p1.second_play && data.p1.second_play) {
          dispatch(timerDisable());
          dispatch(timerReset());
        }

        if (!state.p1.third_play && data.p1.third_play) {
          dispatch(timerDisable());
          dispatch(timerReset());
        }

        if (!state.p2.first_play && data.p2.first_play) {
          dispatch(timerDisable());
          dispatch(timerReset());
        }

        if (!state.p2.second_play && data.p2.second_play) {
          dispatch(timerDisable());
          dispatch(timerReset());
        }

        if (!state.p2.third_play && data.p2.third_play) {
          dispatch(timerDisable());
          dispatch(timerReset());
        }
      }
    }
  } catch (error) {
    if (error.response && error.response.data) {
      if (error.response.data.detail === "Nenhum jogo ativo para este jogador") {
        return dispatch(push("/"));
      }
      toast.error(error.response.data.detail);
    } else {
      toast.error("Erro ao recuperar estado do jogo.");
    }
  }
};

export const playCard = (value, suit) => async (dispatch) => {
  const { game } = store.getState();
  const { flipped } = game;

  try {
    const response = await http.post("games/current/plays", {
      card_played: value + suit,
      flipped,
    });
    playCardSound.play().catch(() => {});
    if (response.status === 200) {
      dispatch(updateCard({ value, suit }));
      if (flipped) {
        dispatch(updateFlipped());
      }
    }
  } catch (error) {
    cantPlayCardSoundAction.play().catch(() => {});
  }
};

export const timerCount = () => async (dispatch) => {
  const { game } = store.getState();
  const { timer, state } = game;

  if (timer && timer !== '--' && timer > 0 && state.truco_challenge_running === 0) {
    dispatch(timerTick());
  }
  setTimeout(() => dispatch(timerCount()), 1000);
};

export const timerTrucoCount = () => async (dispatch) => {
  const { game } = store.getState();
  const { timerTruco, state } = game;

  if (timerTruco !== undefined && timerTruco > 0 && state.truco_challenge_running === 1) {
    dispatch(timerTrucoTick());
  } else {
    dispatch(timerTrucoDisable(undefined));
  }
  setTimeout(() => dispatch(timerTrucoCount()), 1000);
};

export const timerStart = () => async (dispatch) => {
  dispatch(timerCount());
  dispatch(timerTrucoCount());
};

export const truco = () => async (dispatch) => {
  try {
    const response = await http.post("games/current/truco");
    if (response.status === 200) {
    }
  } catch (error) {
    if (error.response && error.response.data) {
      toast.error(error.response.data.detail);
    } else {
      toast.error("Erro ao pedir truco.");
    }
  }
};

export const trucoAccept = () => async (dispatch) => {
  try {
    const response = await http.post("games/current/truco-accept");
  } catch (error) {
    if (error.response && error.response.data) {
      toast.error(error.response.data.detail);
    } else {
      toast.error("Erro ao aceitar o truco.");
    }
  }
};

export const trucoRaise = () => async (dispatch) => {
  try {
    const response = await http.post("games/current/truco-raise");
    if (response.status === 200) {
      toast.success("Aumento a aposta!");
    }
  } catch (error) {
    if (error.response && error.response.data) {
      toast.error(error.response.data.detail);
    } else {
      toast.error("Erro ao aumentar a aposta.");
    }
  }
};

export const trucoRefuse = () => async (dispatch) => {
  try {
    const response = await http.post("games/current/truco-refuse");
  } catch (error) {
    if (error.response && error.response.data) {
      toast.error(error.response.data.detail);
    } else {
      toast.error("Erro ao recusar o truco.");
    }
  }
};

// export const updateTimer = (timeLeft) => async (dispatch) => {
// update do tempo atual
// espera 1 segundo
// verifica se tempo acabou
// se tempo acabou, mostra o aviso de tempo esgotado
// impedir jogador de fazer novas jogadas
// espera atualização do estado no backend
// atualiza tempo atual dispatch(updateTimer({ timeLeft }));
// };

// export const postNewSearch = (keyword) => async (dispatch) => {
//   try {
//     const response = await http.post('crawl', { keyword });
//     if (response.status === 200) {
//       const { id } = response.data;

//       dispatch(addSearch({ id, keyword }));
//       // dispatch(fetchUrlsById(id));
//     }
//   } catch (error) {
//     toast('Error Searching.');
//   }
// };
